(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-item-lot', {
            parent: 'entity',
            url: '/purchase-item-lot?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItemLot.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lots.html',
                    controller: 'PurchaseItemLotController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItemLot');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-item-lot-detail', {
            parent: 'entity',
            url: '/purchase-item-lot/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItemLot.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-detail.html',
                    controller: 'PurchaseItemLotDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItemLot');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseItemLot', function($stateParams, PurchaseItemLot) {
                    return PurchaseItemLot.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-item-lot.new', {
            parent: 'purchase-item-lot',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-dialog.html',
                    controller: 'PurchaseItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                quantity: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('purchase-item-lot');
                });
            }]
        })
        .state('purchase-item-lot.edit', {
            parent: 'purchase-item-lot',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-dialog.html',
                    controller: 'PurchaseItemLotDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseItemLot', function(PurchaseItemLot) {
                            return PurchaseItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-item-lot.delete', {
            parent: 'purchase-item-lot',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item-lot/purchase-item-lot-delete-dialog.html',
                    controller: 'PurchaseItemLotDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseItemLot', function(PurchaseItemLot) {
                            return PurchaseItemLot.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item-lot', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
